import React, { createContext, useContext, useEffect } from "react";
import { DataContext } from "./types/DataContext";
import { User } from "./types/UserData";
import {
  getAuthentication,
  getUserData,
  removeAuthentication,
} from "./lib/auth";

const UserContext = createContext<DataContext | undefined>(undefined);
type Props = {
  children: React.ReactNode;
};
const DataProvider = ({ children }: Props) => {
  const [user, setUser] = React.useState<User | null>(null);
  const [token, setToken] = React.useState<string | null>(null);
  const [isLogin, setIsLogin] = React.useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const authToken = getAuthentication();
      if (authToken) {
        setIsLogin(true);
        setToken(authToken);
        const user = await getUserData(authToken);
        if (user) {
          setUser(user);
        }
      }
    };
    checkAuth();
  }, []);

  const login = (user: User, token: string) => {
    setUser(user);
    setToken(token);
    setIsLogin(true);
  };

  const logout = () => {
    removeAuthentication();
    setUser(null);
    setToken(null);
    setIsLogin(false);
  };
  return (
    <UserContext.Provider value={{ user, token, isLogin, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = (): DataContext => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

export default DataProvider;
